const generateCustomPaletteLabelIndex = (palettes) => {
  if (!palettes.length) {
    return 1;
  }

  const countNumb = palettes.reduce((accum, { id, labelIndex }) => {
    const lastNumber = labelIndex || parseInt(id.split('-').pop(), 10);
    return lastNumber > accum ? lastNumber : accum;
  }, 0);

  return countNumb + 1;
};

export default generateCustomPaletteLabelIndex;
